
import $ from 'jquery';
import Isotope from 'isotope-layout';

$(document).ready(function(){
	
	var masonryLatest = $('.js-masonry__latest')[0];
	// construct an instance of Headroom, passing the element
	if(masonryLatest){
		var masonryLatestNews = new Isotope(masonryLatest, {
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer',
			 	gutter: '.gutter-sizer',
			}
		});
	}
});